import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

export const MACHINE_URL = 'load/machines'

const errors = createHandbookResponseErrors('норму нагрузки', 'норм нагрузки')

export const MachineApi = createNewHandbookApi(MACHINE_URL, errors)
